import React from 'react';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import { Button } from '@gumtree/ui-library';
import styled from '@emotion/styled';
import { VhcFooter, VhcFooterTitle } from '../../common/style';

const BuyButton = styled(Button)`
    && {
        text-decoration: none;
    }
`;
interface Props {
    hpiUrl: string;
}

const Footer: React.FC<Props> = ({ hpiUrl }) => (
    <VhcFooter>
        <p style={{ marginTop: 0 }}>
            Our vehicle history check is provided for guidance only. Please check all the details
            with the seller before purchasing
        </p>
        <VhcFooterTitle>Want a more accurate HPI report?</VhcFooterTitle>
        <p style={{ marginBottom: 0 }}>
            Buy the full report for guaranteed data accuracy, outstanding finance, valuation, milage
            check & VIN match for £9.99 (normally £19.99)
        </p>
        <BuyButton
            display="secondary"
            label="Buy report now"
            shouldOpenNewTab
            href={hpiUrl}
            onClick={() => trackV2('HpiCheckBuyReport')}
        />
    </VhcFooter>
);

export default Footer;
